module.exports = __webpack_public_path__ + "static/media/ic_receipt_24px.8c082921.svg";